import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38773aee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38773aee')) {
      api.createRecord('38773aee', component.options)
    } else {
      api.reload('38773aee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38773aee", function () {
      api.rerender('38773aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/video/index.vue"
export default component.exports